import Base from './base';

class Common extends Base {
  noModel: boolean;
  constructor(noModel = true) {
    super();
    this.noModel = noModel;
  }

  getPath(locale: string, subPath?: string, json = false) {
    const ext = json ? 'json' : 'md';
    return `${this.noModel ? '' : '/' + this.model}/${
      subPath ? locale + '/' + subPath : locale + '.' + ext
    }`;
  }

  getSource(subPath?: string, json?: boolean) {
    const fallback = Array.from(new Set([this.fallback, 'en', 'zh_cn']))
      .filter((t) => Boolean(t) && t !== this.locale)
      .map((t) => this.getPath(t, subPath, json));
    return {
      source: this.getPath(this.locale, subPath, json),
      fallback,
    };
  }
}

export default Common;
